import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sharedialogplugin1f8f3b6a_051e16c1 from 'nuxt_plugin_sharedialogplugin1f8f3b6a_051e16c1' // Source: ./share-dialog.plugin.1f8f3b6a.js (mode: 'all')
import nuxt_plugin_paymedialogplugin915ea7ec_16eb8103 from 'nuxt_plugin_paymedialogplugin915ea7ec_16eb8103' // Source: ./payme-dialog.plugin.915ea7ec.js (mode: 'all')
import nuxt_plugin_paymentqrcodedialogplugin7b9b6735_6020a249 from 'nuxt_plugin_paymentqrcodedialogplugin7b9b6735_6020a249' // Source: ./payment-qrcode-dialog.plugin.7b9b6735.js (mode: 'all')
import nuxt_plugin_pluginutils_71adacc4 from 'nuxt_plugin_pluginutils_71adacc4' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_72f6190f from 'nuxt_plugin_pluginrouting_72f6190f' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5d1504c0 from 'nuxt_plugin_pluginmain_5d1504c0' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vlazyload_037a9a05 from 'nuxt_plugin_vlazyload_037a9a05' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_gtm_28ad4aed from 'nuxt_plugin_gtm_28ad4aed' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_srcpluginf82d62bc_16bd91fb from 'nuxt_plugin_srcpluginf82d62bc_16bd91fb' // Source: ./src.plugin.f82d62bc.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_035bebff from 'nuxt_plugin_cookieuniversalnuxt_035bebff' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_139bda57 from 'nuxt_plugin_axios_139bda57' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_1ddf15b3 from 'nuxt_plugin_workbox_1ddf15b3' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_4da60c74 from 'nuxt_plugin_metaplugin_4da60c74' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_4456c18c from 'nuxt_plugin_iconplugin_4456c18c' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_base_2e224f8c from 'nuxt_plugin_base_2e224f8c' // Source: ../plugins/mixins/base (mode: 'all')
import nuxt_plugin_validation_0214b1bc from 'nuxt_plugin_validation_0214b1bc' // Source: ../plugins/mixins/validation (mode: 'all')
import nuxt_plugin_bootstrap_29b38afa from 'nuxt_plugin_bootstrap_29b38afa' // Source: ../plugins/bootstrap (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_tracking_240dd56c from 'nuxt_plugin_tracking_240dd56c' // Source: ../plugins/tracking.js (mode: 'client')
import nuxt_plugin_browser_6769b2c3 from 'nuxt_plugin_browser_6769b2c3' // Source: ../plugins/browser.js (mode: 'client')
import nuxt_plugin_desktopcatalog_f80f6afa from 'nuxt_plugin_desktopcatalog_f80f6afa' // Source: ../plugins/desktop-catalog.js (mode: 'client')
import nuxt_plugin_locale_28023ea7 from 'nuxt_plugin_locale_28023ea7' // Source: ../plugins/locale.js (mode: 'all')
import nuxt_plugin_lazyscripts_0d0125b2 from 'nuxt_plugin_lazyscripts_0d0125b2' // Source: ../plugins/lazy-scripts.js (mode: 'client')
import nuxt_plugin_plugin_78558a53 from 'nuxt_plugin_plugin_78558a53' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_oauth_3bdb11f4 from 'nuxt_plugin_oauth_3bdb11f4' // Source: ../plugins/oauth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"zh-Hant-HK"},"meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:locale","name":"og:locale","property":"og:locale","content":"zh_HK"}],"link":[{"hid":"swiper-css","rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fswiper@11\u002Fswiper-bundle.min.css","media":"print","onload":"this.media='all'"}],"__dangerouslyDisableSanitizersByTagID":{"swiper-css":["onload"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"script":[{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcode.jquery.com\u002Fjquery-3.7.1.min.js","defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fautosize.js\u002F4.0.2\u002Fautosize.min.js","defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fswiper@11\u002Fswiper-bundle.min.js","defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fmaps.googleapis.com\u002Fmaps\u002Fapi\u002Fjs?key=AIzaSyDRsCWRbM_i3F_Wxt_mr9DJ-420k_qmkrs&libraries=places&language=zh-HK&loading=async","async":true,"defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fsimplemde\u002Flatest\u002Fsimplemde.min.js","defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TM482P6')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TM482P6&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_sharedialogplugin1f8f3b6a_051e16c1 === 'function') {
    await nuxt_plugin_sharedialogplugin1f8f3b6a_051e16c1(app.context, inject)
  }

  if (typeof nuxt_plugin_paymedialogplugin915ea7ec_16eb8103 === 'function') {
    await nuxt_plugin_paymedialogplugin915ea7ec_16eb8103(app.context, inject)
  }

  if (typeof nuxt_plugin_paymentqrcodedialogplugin7b9b6735_6020a249 === 'function') {
    await nuxt_plugin_paymentqrcodedialogplugin7b9b6735_6020a249(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_71adacc4 === 'function') {
    await nuxt_plugin_pluginutils_71adacc4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_72f6190f === 'function') {
    await nuxt_plugin_pluginrouting_72f6190f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_5d1504c0 === 'function') {
    await nuxt_plugin_pluginmain_5d1504c0(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_037a9a05 === 'function') {
    await nuxt_plugin_vlazyload_037a9a05(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_28ad4aed === 'function') {
    await nuxt_plugin_gtm_28ad4aed(app.context, inject)
  }

  if (typeof nuxt_plugin_srcpluginf82d62bc_16bd91fb === 'function') {
    await nuxt_plugin_srcpluginf82d62bc_16bd91fb(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_035bebff === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_035bebff(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_139bda57 === 'function') {
    await nuxt_plugin_axios_139bda57(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_1ddf15b3 === 'function') {
    await nuxt_plugin_workbox_1ddf15b3(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_4da60c74 === 'function') {
    await nuxt_plugin_metaplugin_4da60c74(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_4456c18c === 'function') {
    await nuxt_plugin_iconplugin_4456c18c(app.context, inject)
  }

  if (typeof nuxt_plugin_base_2e224f8c === 'function') {
    await nuxt_plugin_base_2e224f8c(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_0214b1bc === 'function') {
    await nuxt_plugin_validation_0214b1bc(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrap_29b38afa === 'function') {
    await nuxt_plugin_bootstrap_29b38afa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tracking_240dd56c === 'function') {
    await nuxt_plugin_tracking_240dd56c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_browser_6769b2c3 === 'function') {
    await nuxt_plugin_browser_6769b2c3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_desktopcatalog_f80f6afa === 'function') {
    await nuxt_plugin_desktopcatalog_f80f6afa(app.context, inject)
  }

  if (typeof nuxt_plugin_locale_28023ea7 === 'function') {
    await nuxt_plugin_locale_28023ea7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyscripts_0d0125b2 === 'function') {
    await nuxt_plugin_lazyscripts_0d0125b2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_78558a53 === 'function') {
    await nuxt_plugin_plugin_78558a53(app.context, inject)
  }

  if (typeof nuxt_plugin_oauth_3bdb11f4 === 'function') {
    await nuxt_plugin_oauth_3bdb11f4(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
